module.exports = __webpack_public_path__ + "fb5007a3a29732129ed2677617440b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/detsky-tabor-1-7.jpg
// module id = 1217
// module chunks = 0